import { useCallback, useRef } from "react";
import { productAnalytics } from "./product-analytics";

// Leading only, as in the legacy hook's noTrailing=true. Never queue a click
// that could run after a visitor switch or after navigation to the file.
function useThrottledClick(callback: (key: string) => void) {
  const last = useRef<{ distinctId: string; time: number } | undefined>(undefined);
  return useCallback(
    (key: string) => {
      const distinctId = productAnalytics.getDistinctId();
      if (!distinctId) return;
      const time = performance.now();
      // Revalidating the same principal must not reopen the leading-only window.
      if (last.current?.distinctId === distinctId && time - last.current.time < 10000) return;
      last.current = { distinctId, time };
      callback(key);
    },
    [callback],
  );
}

const deliverableClick = (deliverableIntegrationKey: string) =>
  productAnalytics.track("Deliverable Download Clicked", { deliverableIntegrationKey });
const projectZipClick = (projectIntegrationKey: string) =>
  productAnalytics.track("Project ZIP Download Clicked", { projectIntegrationKey });

export const useTrackDownload = () => {
  const trackDownloadDeliverable = useThrottledClick(deliverableClick);
  const trackDownloadProjectZip = useThrottledClick(projectZipClick);

  return {
    trackDownloadDeliverable,
    trackDownloadProjectZip,
  };
};
